import styled from 'styled-components';

export const CommunicationsDrawerWrapper = styled.span``;
